import "core-js/modules/web.timers.js";
export default {
  __name: 'DrawerTint',
  setup: function setup(__props) {
    var _useNuxtApp = useNuxtApp(),
      $cropContent = _useNuxtApp.$cropContent;
    var modalityStore = useModalityStore();
    var bodyClassName = computed(function () {
      if (modalityStore.cart) return 'cart-open';
      return 'drawer-open';
    });
    var el = null;
    onMounted(function () {
      el = document.getElementById('__layout');
    });
    var shown = computed(function () {
      return modalityStore.tintShown;
    });
    watch(shown, function (newVal) {
      if (newVal) {
        $cropContent();
        requestAnimationFrame(function () {
          el.classList.add('push-content');
          requestAnimationFrame(function () {
            if (shown.value) {
              el.classList.add(bodyClassName.value);
            }
          });
        });
      } else {
        el.classList.remove('cart-open', 'drawer-open');
        if (!process.client) return;

        // TODO: Improve timing for class removal
        setTimeout(function () {
          // Use requestAnimationFrame to handle edge cases where the tab is in the background
          // This ensures the class 'push-content' is removed even if the tab regains focus later
          requestAnimationFrame(function () {
            if (!shown.value) el.classList.remove('push-content');
          });
        }, 350);
      }
    });
    function closeAll(e) {
      e.stopPropagation();
      modalityStore.closeModal({
        type: 'drawer'
      });
      modalityStore.closeModal({
        type: 'gain'
      });
      modalityStore.closeModal({
        type: 'cart'
      });
    }
    return {
      __sfc: true,
      $cropContent: $cropContent,
      modalityStore: modalityStore,
      bodyClassName: bodyClassName,
      el: el,
      shown: shown,
      closeAll: closeAll
    };
  }
};